import styled from 'styled-components'

export const AlertWrapper = styled.div`
  position: fixed;
  top: 80px;
  right: 30px;
  z-index: 999;
  max-width: 380px;

  .mantine-Alert-root {
    background: ${({ theme }) => theme.alerta.warning.background};
  }

  .mantine-Alert-message,
  .mantine-Alert-closeButton {
    color: ${({ theme }) => theme.cor9}!important;
  }

  .mantine-Alert-title {
    color: ${({ theme }) => theme.alerta.warning.color};
  }

  svg > path {
    fill: ${({ theme }) => theme.alerta.warning.color};
  }
`
